import React from 'react';
import { ButtonProps } from '../../../../components/menus/buttons/types';
import EditorLayoutGrid from '@wix/da-ds/pkg/Icons/24x24/EditorLayoutGrid';
import EditorLayoutTorpedo from '@wix/da-ds/pkg/Icons/24x24/EditorLayoutTorpedo';
import { useTranslation } from 'react-i18next';
import EditorIconButtonWithContextMenu from '../../../../components/menus/_partials/EditorIconButtonWithContextMenu';

const Layout: React.FC<ButtonProps> = ({ editor }) => {
  const { t } = useTranslation('editor');
  let CurrentIcon = EditorLayoutGrid;
  if (editor.isActive('da-gallery', { layout: 'torpedo' })) {
    CurrentIcon = EditorLayoutTorpedo;
  }
  if (!editor.can().chain().focus().daGalleryChangeLayout('grid').run()) {
    return null;
  }
  return (
    <EditorIconButtonWithContextMenu
      featureId="node:gallery:layout"
      aria-label={t('ext.gallery.button.layout')}
      tooltipText={t('ext.gallery.button.layout')}
      icon={CurrentIcon}
      items={[
        {
          featureId: 'node:gallery:gridLayout',
          label: 'Grid',
          icon: <EditorLayoutGrid />,
          selected: editor.isActive('da-gallery', { layout: 'grid' }),
          onClick: () => {
            editor.chain().focus().daGalleryChangeLayout('grid').run();
          },
        },
        {
          featureId: 'node:gallery:masonryLayout',
          label: 'Masonry',
          icon: <EditorLayoutTorpedo />,
          selected: editor.isActive('da-gallery', { layout: 'torpedo' }),
          onClick: () => {
            editor.chain().focus().daGalleryChangeLayout('torpedo').run();
          },
        },
      ]}
    />
  );
};
Layout.displayName = 'Layout';

export default Layout;
